module.exports = __webpack_public_path__ + "static/media/(000136).756fe30a.jpg";